import React from 'react';
import { steps } from '../data/content';
import { Brand } from './Brand';
export function HowItWorks() {
  return <section className="w-full border-y border-slate-900/10 bg-stone-100 px-8 py-24 sm:px-14 sm:py-32" data-id="element-180" data-mp="7twrut8kyzg2">
      <div className="mx-auto max-w-6xl" data-id="element-181" data-mp="3pzjjy9320q1d">
        <div className="grid gap-8 lg:grid-cols-12 lg:items-end" data-id="element-182" data-mp="3q0unc7sl7vry">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl lg:col-span-7" data-id="element-183" data-mp="3u0v4i072ml2p">
            <em className="text-red-700" data-id="element-184" data-mp="lmcye40oxflq"><Brand data-id="element-185" data-mp="qj3g0vs58j99" /></em> 怎樣用
          </h2>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-5" data-id="element-186" data-mp="qi1tnv5ogac8">
            由下載到上課：五分鐘就備好下一節音樂課。
          </p>
        </div>

        <ol className="mt-16 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8" data-id="element-187" data-mp="gtjvzmsp2jct">
          {steps.map((step, index) => <li key={step.title} className="relative border-t-2 border-slate-900 pt-6" data-id="element-188" data-mp="14je5budt1psb" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700" aria-hidden="true" data-id="element-189" data-mp="199ulhm90fpid">
                {index + 1}
              </span>
              <h3 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-190" data-mp="2rmfrwjaagcm1">
                <span className="sr-only" data-id="element-191" data-mp="2mnmesrywynme">第 {index + 1} 步：</span>
                {step.title}
              </h3>
              <p className="mt-2 leading-relaxed text-slate-900/70" data-id="element-192" data-mp="31c933j6iqppr">{step.text}</p>
            </li>)}
        </ol>

        <p className="mt-16 text-center font-serif text-2xl italic leading-snug text-slate-900/80 sm:text-3xl" data-id="element-193" data-mp="2wjg0b0um1rgb">
          打開 → 選擇 → 準備 → 上課。簡單又有條理。
        </p>
      </div>
    </section>;
}